const SetBlockEdges = () => {
	const blocks = document.querySelectorAll('#main > .acf-block');

	for (let i = 0; i < blocks.length; i++) {
		if (
			'3' === blocks[i].getAttribute('data-color-mode') ||
			blocks[i].classList.contains('block-hero-frame')
		) {
			continue;
		}

		if (0 === i) {
			return;
		}

		const bgColor = blocks[i].getAttribute('data-bg-color');

		blocks[i - 1].style.setProperty('--blockRadiusColor', bgColor);
		break;
	}

	const footer = document.querySelector('#footer');
	const lastBlock = blocks[blocks.length - 1];

	if (footer && lastBlock) {
		const bgColor = lastBlock.getAttribute('data-bg-color');
		footer.style.setProperty('--blockRadiusColor', bgColor);
	}
};

export default SetBlockEdges;
